import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AddonPacksService from '../../../Api/AddonPacksService';

const ViewAddonPacks = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const packId = new URLSearchParams(location.search).get('id');
    const PackAPI = new AddonPacksService();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [packData, setPackData] = useState(null);

    useEffect(() => {
        const fetchPack = async () => {
            try {
                setLoading(true);
                const response = await PackAPI.GetById(packId);
                if (response.data && response.data.data) {
                    setPackData(response.data.data);
                }
            } catch (err) {
                setError('Failed to load addon pack data. Please try again.');
                console.error('Error loading addon pack:', err);
            } finally {
                setLoading(false);
            }
        };

        if (packId) {
            fetchPack();
        } else {
            navigate('/addon-packs-list');
        }
    }, [packId, navigate]);

    if (loading) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger m-4" role="alert">
                {error}
            </div>
        );
    }

    if (!packData) {
        return (
            <div className="alert alert-warning m-4" role="alert">
                Addon pack not found.
            </div>
        );
    }

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-24">
                    <h4 className="text-xl text-primary-light">View Addon Pack</h4>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => navigate('/addon-packs-list')}
                    >
                        <Icon icon="mdi:arrow-left" /> Back to List
                    </button>
                </div>

                <div className="row g-4">
                    <div className="col-md-4">
                        {packData.thumbnail_url && (
                            <div className="mb-4">
                                <img 
                                    src={packData.thumbnail_url} 
                                    alt="Pack thumbnail" 
                                    className="img-fluid rounded"
                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                            </div>
                        )}

                        <div className="info-group mb-3">
                            <label className="text-muted">Price</label>
                            <p className="h5">₹{packData.price}</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Points Provided</label>
                            <p className="h5">{packData.points_provided}</p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Status</label>
                            <p>
                                <span className={`badge ${packData.is_active ? 'bg-success' : 'bg-danger'}`}>
                                    {packData.is_active ? 'Active' : 'Inactive'}
                                </span>
                            </p>
                        </div>

                        <div className="info-group mb-3">
                            <label className="text-muted">Created At</label>
                            <p className="h6">
                                {new Date(packData.created_at).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-8">
                        <div className="info-group mb-4">
                            <label className="text-muted">Pack Name</label>
                            <h3>{packData.pack_name}</h3>
                        </div>

                        <div className="info-group mb-4">
                            <label className="text-muted">Description</label>
                            <p className="text-justify">{packData.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewAddonPacks;
